import * as React from 'react';
import Lottie from 'react-lottie';
import { css, StyleSheet } from 'aphrodite';
import { Colors, icon, MediaBreakPointUp } from '@lean-body/components/styles/';
import * as animationData from '../../lotties/favorite_heart.json';
export const ButtonFavorite = (props) => {
    const options = {
        loop: false,
        animationData: animationData,
    };
    const styles = StyleSheet.create({
        buttonCommon: {
            cursor: 'pointer',
            backgroundColor: props.isStopped ? Colors.White : Colors.Primary,
            borderRadius: '50%',
            border: 'none',
            color: Colors.Primary,
            padding: 0, // user agentのデフォルトでpaddingがあるので消す
            boxShadow: `0px 15px 30px rgba(0, 180, 199, 0.08)`,
        },
        button: {
            position: 'relative',
            width: 32,
            height: 32,
            border: `1px solid ${Colors.BorderLightGrayB}`,
            [MediaBreakPointUp.MD]: {
                width: 44,
                height: 44,
            },
        },
        innerCommon: {
            // Lottieを中央に寄せるcss
            position: 'absolute',
            top: 0,
            right: 0,
            left: 0,
            bottom: 0,
            // anticonを中央に寄せるcss
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
        },
    });
    const innerClass = props.innerClassName
        ? [css(styles.innerCommon), props.innerClassName].join(' ')
        : css(styles.innerCommon);
    const buttonClass = props.buttonClassName
        ? [css(styles.buttonCommon), props.buttonClassName].join(' ')
        : css(styles.buttonCommon, styles.button);
    return (React.createElement("button", { className: buttonClass, onClick: props.onClick },
        React.createElement("div", { className: innerClass, "data-test": "favButton" },
            React.createElement(Icon, { isStopped: props.isStopped, options: options, iconClass: props.iconClassName }))));
};
const Icon = ({ isStopped, options, iconClass }) => {
    const styles = StyleSheet.create({
        icon: {
            fontSize: 16,
            [MediaBreakPointUp.MD]: {
                fontSize: 20,
            },
        },
    });
    const favIcon = iconClass ? iconClass : css(styles.icon);
    const iconClassName = [css(icon.anticon), css(icon.anticonHeart), favIcon].join(' ');
    if (isStopped) {
        return React.createElement("i", { className: iconClassName });
    }
    return React.createElement(Lottie, { options: options, isStopped: isStopped });
};
